/**
 * Created by RKL on 13/08/2015.
 */
define('mbAnaDetailView',[
  'module',
  'mbAnaCreateEditLayoutView',
  'underscore',
  'marionette',
  'template!mbAnaDetailTabTpl'
], function (
  module,
  CreateEditLayoutView,
  _,
  Marionette,
  viewTpl
) {
  'use strict';

  var MbAnaDetailView = Marionette.ItemView.extend({
    template: viewTpl,

    modelEvents: {
      change: 'render'
    },

    events: {
      'click .js-edit': '_onEdit'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.viewLess = this.model.get('secId');
      return templateData;
    },

    _onEdit: function() {
      var createEditView = new CreateEditLayoutView({
        mbanaModel: this.model
      });
      createEditView.show({
        title: _.i18n('mbana.edit')
      });
    }

  });

  module.exports = MbAnaDetailView;
});
